module.exports = __webpack_public_path__ + "assets/img/20210924-6.daede2ee.png";